/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type CohortFilterConfigColumn = (typeof CohortFilterConfigColumn)[keyof typeof CohortFilterConfigColumn];

export const CohortFilterConfigColumn = {
  cohort: 'cohort',
} as const;
